import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  span {
    width: 160px;
    background: #000b3a;
    color: #fff;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.4s ease;

    position: absolute;
    bottom: calc(100% + 12px);
    right: 50%;
    transform: translateX(20%);

    &::before {
      content: '';
      border-style: solid;
      border-color: #000b3a transparent;
      border-width: 6px 6px 0 6px;
      bottom: 20px;
      top: 100%;
      position: absolute;
      left: 80%;
      transform: translateX(-50%);
    }
  }

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
